export const es = {
  menu: {
    root: 'Producción',
    workOrders: 'Órdenes de Trabajo',
    processingTypes: 'Tipos de Procesamiento',
    tollAgreements: 'Acuerdos de Maquila',
    tollProcessingAgreements: 'Acuerdos de Maquila de Procesamiento',
    tollReceipts: 'Recibos de Maquila',
    tollShipments: 'Envíos de Maquila',
  },
  workOrdersView: {
    title: 'Órdenes de Trabajo',
    subtitle: 'Administrar órdenes de trabajo de procesamiento',
    createWorkOrder: 'Crear Orden de Trabajo',
    filters: {
      search: 'Buscar órdenes de trabajo...',
      allStatuses: 'Todos los Estados',
      allProcessingTypes: 'Todos los Tipos de Procesamiento',
      allFacilities: 'Todas las Instalaciones',
    },
    summary: {
      total: 'Total',
      draft: 'Borrador',
      open: 'Abierta',
      inProgress: 'En Progreso',
      completed: 'Completada',
      cancelled: 'Cancelada',
    },
    table: {
      aria: 'Lista de Órdenes de Trabajo',
      columns: {
        workOrderNumber: 'Orden de Trabajo #',
        status: 'Estado',
        processingType: 'Tipo de Procesamiento',
        facility: 'Instalación',
        scheduledStart: 'Inicio Programado',
        scheduledEnd: 'Fin Programado',
        createdAt: 'Creado',
      },
    },
    statusTypes: {
      Draft: 'Borrador',
      Open: 'Abierta',
      InProgress: 'En Progreso',
      Completed: 'Completada',
      Cancelled: 'Cancelada',
    },
    tollingTypes: {
      None: 'Ninguno',
      Outbound: 'Saliente (Procesamiento Externo)',
      Inbound: 'Entrante (Maquila de Cliente)',
    },
    content: {
      error: (message: string) =>
        `Error al cargar órdenes de trabajo: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron órdenes de trabajo',
      subtitle:
        'Ninguna orden de trabajo coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree una nueva orden de trabajo.',
    },
    dialog: {
      createTitle: 'Crear Orden de Trabajo',
      editTitle: 'Editar Orden de Trabajo',
      processingTypeLabel: 'Tipo de Procesamiento',
      processingTypePlaceholder: 'Seleccione tipo de procesamiento...',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione instalación...',
      scheduledStartLabel: 'Inicio Programado',
      scheduledStartTimeLabel: 'Hora de Inicio',
      scheduledEndLabel: 'Fin Programado',
      scheduledEndTimeLabel: 'Hora de Fin',
      notesLabel: 'Notas',
      notesPlaceholder: 'Ingrese notas...',
      isTollingLabel: 'Procesamiento Externo (Maquila)',
      tollAgreementLabel: 'Acuerdo de Maquila',
      tollAgreementPlaceholder: 'Seleccione acuerdo de maquila...',
      cancel: 'Cancelar',
      create: 'Crear Orden de Trabajo',
      creating: 'Creando...',
      update: 'Actualizar Orden de Trabajo',
      updating: 'Actualizando...',
      createSuccess: 'Orden de trabajo creada exitosamente',
      updateSuccess: 'Orden de trabajo actualizada exitosamente',
      createError: (message: string) =>
        `Error al crear orden de trabajo: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar orden de trabajo: ${message}`,
      validation: {
        processingTypeRequired: 'El tipo de procesamiento es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
        inputItemRequired: 'Seleccione un artículo para todos los insumos',
        outputItemRequired: 'Seleccione un artículo para todos los productos',
        quantityRequired: 'La cantidad debe ser mayor a 0',
      },
      sourceLot: {
        title: 'Lote de Origen (Opcional)',
        description:
          'Seleccione un lote para usar todo su contenido como insumo, o salte para agregar insumos manualmente.',
        selectLabel: 'Lote de Origen',
        selectPlaceholder: 'Seleccione lote a consumir...',
      },
      inputItems: {
        title: 'Insumos',
        add: 'Agregar Insumo',
        empty:
          'No se han agregado insumos. Haga clic en "Agregar Insumo" para agregar materiales a consumir.',
        emptyLot: 'El lote seleccionado no tiene artículos.',
        selectItem: 'Seleccione artículo...',
        quantity: 'Cant.',
        unit: 'Unidad',
        notes: 'Notas',
        remove: 'Eliminar insumo',
      },
      outputItems: {
        title: 'Productos',
        add: 'Agregar Producto',
        empty:
          'No se han agregado productos. Haga clic en "Agregar Producto" para agregar productos esperados.',
        selectItem: 'Seleccione artículo...',
        quantity: 'Cant.',
        unit: 'Unidad',
        notes: 'Notas',
        remove: 'Eliminar producto',
      },
      calculation: {
        title: 'Calcular desde Receta',
        noRecipe: 'Este tipo de procesamiento no tiene una receta definida.',
        hasRecipe:
          'Este tipo de procesamiento tiene una receta. Puede calcular cantidades automáticamente.',
        direction: 'Dirección de Cálculo',
        fromInputs: 'Desde Insumos',
        fromInputsDesc:
          'Ingrese cantidad de insumos, calcule productos esperados',
        fromOutputs: 'Desde Productos',
        fromOutputsDesc: 'Ingrese producto deseado, calcule insumos requeridos',
        referenceItem: 'Artículo de Referencia',
        referenceQuantity: 'Cantidad',
        referenceUnit: 'Unidad',
        apply: 'Aplicar Receta',
        applying: 'Aplicando...',
        scaleFactor: 'Factor de Escala',
        clear: 'Limpiar Artículos',
        applySuccess: 'Receta aplicada exitosamente',
        selectProcessingTypeFirst:
          'Seleccione un tipo de procesamiento para usar el cálculo de receta',
      },
    },
    actions: {
      open: 'Abrir',
      start: 'Iniciar Procesamiento',
      complete: 'Completar',
      cancel: 'Cancelar',
    },
  },
  workOrderDetailView: {
    title: (workOrderNumber: string) => `Orden de Trabajo ${workOrderNumber}`,
    backToList: 'Volver a Órdenes de Trabajo',
    tabs: {
      overview: 'Resumen',
      inputItems: 'Insumos',
      outputItems: 'Productos',
    },
    overview: {
      processingType: 'Tipo de Procesamiento',
      facility: 'Instalación',
      scheduledStart: 'Inicio Programado',
      scheduledEnd: 'Fin Programado',
      actualStart: 'Inicio Real',
      actualEnd: 'Fin Real',
      notes: 'Notas',
      isTolling: 'Procesamiento Externo',
      tollAgreement: 'Acuerdo de Maquila',
      createdBy: 'Creado Por',
    },
    inputItems: {
      title: 'Insumos',
      add: 'Agregar Insumo',
      table: {
        aria: 'Tabla de Insumos',
        columns: {
          item: 'Artículo',
          lot: 'Lote',
          tag: 'Etiqueta',
          plannedQuantity: 'Cant. Planificada',
          actualQuantity: 'Cant. Real',
          unitCost: 'Costo Unitario',
          notes: 'Notas',
        },
      },
      emptyState: {
        title: 'Sin insumos',
        subtitle: 'Agregue insumos a esta orden de trabajo.',
      },
    },
    outputItems: {
      title: 'Productos',
      add: 'Agregar Producto',
      table: {
        aria: 'Tabla de Productos',
        columns: {
          item: 'Artículo',
          targetLot: 'Lote Destino',
          targetTag: 'Etiqueta Destino',
          expectedQuantity: 'Cant. Esperada',
          actualQuantity: 'Cant. Real',
          yieldPercentage: 'Rendimiento %',
          notes: 'Notas',
        },
      },
      emptyState: {
        title: 'Sin productos',
        subtitle: 'Agregue productos a esta orden de trabajo.',
      },
    },
    itemsEdit: {
      editButton: 'Editar Artículos',
      save: 'Guardar',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      saveSuccess: 'Artículos actualizados exitosamente',
      saveError: (message: string) =>
        `Error al actualizar artículos: ${message}`,
      addInput: 'Agregar Insumo',
      addOutput: 'Agregar Producto',
      confirmCancel: '¿Descartar cambios sin guardar?',
    },
    completionDialog: {
      title: 'Completar Orden de Trabajo',
      subtitle: 'Ingrese cantidades reales para completar',
      inputItemsTitle: 'Insumos - Cantidades Reales',
      outputItemsTitle: 'Productos - Cantidades Reales',
      itemColumn: 'Artículo',
      plannedColumn: 'Planificado',
      expectedColumn: 'Esperado',
      actualColumn: 'Cant. Real',
      unitColumn: 'Unidad',
      lotColumn: 'Lote',
      targetLotColumn: 'Lote Destino',
      createNewLot: 'Crear Nuevo Lote',
      selectLot: 'Seleccionar lote...',
      selectTag: 'Seleccionar etiqueta...',
      tagColumn: 'Etiqueta',
      targetTagColumn: 'Etiqueta Destino',
      cancel: 'Cancelar',
      complete: 'Completar Orden de Trabajo',
      completing: 'Completando...',
      completeSuccess: 'Orden de trabajo completada exitosamente',
      completeError: (message: string) =>
        `Error al completar orden de trabajo: ${message}`,
      validation: {
        actualQuantityRequired:
          'La cantidad real es obligatoria para todos los artículos',
      },
    },
  },
  processingTypesView: {
    title: 'Tipos de Procesamiento',
    subtitle: 'Configurar operaciones de procesamiento disponibles',
    createProcessingType: 'Crear Tipo de Procesamiento',
    filters: {
      search: 'Buscar tipos de procesamiento...',
      showInactive: 'Mostrar inactivos',
    },
    table: {
      aria: 'Lista de Tipos de Procesamiento',
      columns: {
        name: 'Nombre',
        code: 'Código',
        description: 'Descripción',
        isActive: 'Activo',
        createdAt: 'Creado',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar tipos de procesamiento: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron tipos de procesamiento',
      subtitle:
        'Ningún tipo de procesamiento coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo tipo de procesamiento.',
    },
    dialog: {
      createTitle: 'Crear Tipo de Procesamiento',
      editTitle: 'Editar Tipo de Procesamiento',
      nameLabel: 'Nombre',
      namePlaceholder: 'Ingrese nombre...',
      codeLabel: 'Código',
      codePlaceholder: 'Ingrese código (ej., TRITURAR)',
      descriptionLabel: 'Descripción',
      descriptionPlaceholder: 'Ingrese descripción...',
      isActiveLabel: 'Activo',
      cancel: 'Cancelar',
      create: 'Crear',
      creating: 'Creando...',
      update: 'Actualizar',
      updating: 'Actualizando...',
      createSuccess: 'Tipo de procesamiento creado exitosamente',
      updateSuccess: 'Tipo de procesamiento actualizado exitosamente',
      createError: (message: string) =>
        `Error al crear tipo de procesamiento: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar tipo de procesamiento: ${message}`,
      validation: {
        nameRequired: 'El nombre es obligatorio',
        codeRequired: 'El código es obligatorio',
      },
      recipe: {
        inputsTitle: 'Insumos de Receta',
        outputsTitle: 'Productos de Receta',
        addInput: 'Agregar Insumo',
        addOutput: 'Agregar Producto',
        selectItem: 'Seleccione artículo...',
        yieldPercentage: 'Rendimiento %',
        outputUnit: 'Unidad',
        isPrimary: 'Principal',
        isNoCost: 'Sin Costo',
        costAllocation: 'Costo %',
        notes: 'Notas',
        noRecipe: 'Sin receta definida',
        emptyInputs:
          'No hay insumos definidos. Haga clic en "Agregar Insumo" para definir insumos de receta.',
        emptyOutputs:
          'No hay productos definidos. Haga clic en "Agregar Producto" para definir productos de receta.',
        removeInput: 'Eliminar insumo',
        removeOutput: 'Eliminar producto',
        inputHeaders: {
          item: 'Artículo',
          primary: 'Principal',
          notes: 'Notas',
        },
        outputHeaders: {
          item: 'Artículo',
          yieldPercentage: 'Rendimiento %',
          outputUnit: 'Unidad',
          primary: 'Principal',
          noCost: 'Sin Costo',
          costPercent: 'Costo %',
          notes: 'Notas',
        },
        validation: {
          needsPrimaryInput:
            'La receta debe tener exactamente un insumo principal',
          noCostBearingOutputs:
            'La receta debe tener al menos un producto con costo asignado',
          allocationMustSum100:
            'Los porcentajes de asignación de costo deben sumar 100%',
          inputItemRequired: 'Seleccione un artículo para todos los insumos',
          outputItemRequired: 'Seleccione un artículo para todos los productos',
          yieldPercentageRequired:
            'El porcentaje de rendimiento debe estar entre 0 y 100',
        },
      },
    },
  },
  tollAgreementsView: {
    title: 'Acuerdos de Maquila',
    subtitle: 'Administrar acuerdos de procesamiento externo',
    createTollAgreement: 'Crear Acuerdo de Maquila',
    filters: {
      search: 'Buscar acuerdos de maquila...',
      allProcessingTypes: 'Todos los Tipos de Procesamiento',
      showInactive: 'Mostrar inactivos',
    },
    table: {
      aria: 'Lista de Acuerdos de Maquila',
      columns: {
        agreementNumber: 'Acuerdo #',
        processor: 'Procesador',
        processingType: 'Tipo de Procesamiento',
        effectiveDate: 'Fecha de Vigencia',
        expirationDate: 'Fecha de Vencimiento',
        pricePerUnit: 'Precio/Unidad',
        isActive: 'Activo',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar acuerdos de maquila: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron acuerdos de maquila',
      subtitle:
        'Ningún acuerdo de maquila coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo acuerdo de maquila.',
    },
    dialog: {
      createTitle: 'Crear Acuerdo de Maquila',
      editTitle: 'Editar Acuerdo de Maquila',
      agreementNumberLabel: 'Número de Acuerdo',
      agreementNumberPlaceholder: 'Ingrese número de acuerdo...',
      processorLabel: 'Procesador',
      processorPlaceholder: 'Seleccione procesador...',
      processingTypeLabel: 'Tipo de Procesamiento',
      processingTypePlaceholder: 'Seleccione tipo de procesamiento...',
      effectiveDateLabel: 'Fecha de Vigencia',
      expirationDateLabel: 'Fecha de Vencimiento',
      pricePerUnitLabel: 'Precio por Unidad',
      priceUnitLabel: 'Unidad de Precio',
      priceUnitPlaceholder: 'ej., lb, ton',
      expectedYieldLabel: 'Rendimiento Esperado %',
      termsLabel: 'Términos',
      termsPlaceholder: 'Ingrese términos...',
      isActiveLabel: 'Activo',
      facilityLabel: 'Instalación',
      cancel: 'Cancelar',
      create: 'Crear',
      creating: 'Creando...',
      update: 'Actualizar',
      updating: 'Actualizando...',
      createSuccess: 'Acuerdo de maquila creado exitosamente',
      updateSuccess: 'Acuerdo de maquila actualizado exitosamente',
      createError: (message: string) =>
        `Error al crear acuerdo de maquila: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar acuerdo de maquila: ${message}`,
      validation: {
        agreementNumberRequired: 'El número de acuerdo es obligatorio',
        processorRequired: 'El procesador es obligatorio',
        processingTypeRequired: 'El tipo de procesamiento es obligatorio',
        effectiveDateRequired: 'La fecha de vigencia es obligatoria',
      },
    },
  },
  tollProcessingAgreementsView: {
    title: 'Acuerdos de Maquila de Procesamiento',
    subtitle:
      'Administrar acuerdos de maquila de procesamiento entrante con clientes',
    createTollProcessingAgreement: 'Crear Acuerdo',
    filters: {
      search: 'Buscar acuerdos de maquila de procesamiento...',
      allProcessingTypes: 'Todos los Tipos de Procesamiento',
      allCustomers: 'Todos los Clientes',
      showInactive: 'Mostrar inactivos',
    },
    table: {
      aria: 'Lista de Acuerdos de Maquila de Procesamiento',
      columns: {
        agreementNumber: 'Acuerdo #',
        customer: 'Cliente',
        processingType: 'Tipo de Procesamiento',
        effectiveDate: 'Fecha de Vigencia',
        expirationDate: 'Fecha de Vencimiento',
        pricePerUnit: 'Precio/Unidad',
        isActive: 'Activo',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar acuerdos de maquila de procesamiento: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron acuerdos de maquila de procesamiento',
      subtitle:
        'Ningún acuerdo de maquila de procesamiento coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo acuerdo.',
    },
    dialog: {
      createTitle: 'Crear Acuerdo de Maquila de Procesamiento',
      editTitle: 'Editar Acuerdo de Maquila de Procesamiento',
      agreementNumberLabel: 'Número de Acuerdo',
      agreementNumberPlaceholder: 'Ingrese número de acuerdo...',
      customerLabel: 'Cliente',
      customerPlaceholder: 'Ingrese ID de cuenta de cliente...',
      processingTypeLabel: 'Tipo de Procesamiento',
      processingTypePlaceholder: 'Seleccione tipo de procesamiento...',
      effectiveDateLabel: 'Fecha de Vigencia',
      expirationDateLabel: 'Fecha de Vencimiento',
      pricePerUnitLabel: 'Tarifa de Procesamiento por Unidad',
      priceUnitLabel: 'Unidad de Tarifa',
      priceUnitPlaceholder: 'ej., lb, ton',
      expectedYieldLabel: 'Rendimiento Esperado %',
      invoicePricingBasisLabel: 'Base de Precios de Factura',
      termsLabel: 'Términos',
      termsPlaceholder: 'Ingrese términos...',
      isActiveLabel: 'Activo',
      facilityLabel: 'Instalación',
      cancel: 'Cancelar',
      create: 'Crear',
      creating: 'Creando...',
      update: 'Actualizar',
      updating: 'Actualizando...',
      createSuccess: 'Acuerdo de maquila de procesamiento creado exitosamente',
      updateSuccess:
        'Acuerdo de maquila de procesamiento actualizado exitosamente',
      createError: (message: string) =>
        `Error al crear acuerdo de maquila de procesamiento: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar acuerdo de maquila de procesamiento: ${message}`,
      validation: {
        agreementNumberRequired: 'El número de acuerdo es obligatorio',
        customerRequired: 'El cliente es obligatorio',
        processingTypeRequired: 'El tipo de procesamiento es obligatorio',
        effectiveDateRequired: 'La fecha de vigencia es obligatoria',
      },
    },
  },
  tollReceiptsView: {
    title: 'Recibos de Maquila',
    subtitle: 'Seguimiento de recibos de material de maquila entrante',
    createTollReceipt: 'Crear Recibo de Maquila',
    filters: {
      search: 'Buscar recibos de maquila...',
      allCustomers: 'Todos los Clientes',
      allAgreements: 'Todos los Acuerdos',
      allFacilities: 'Todas las Instalaciones',
      allStatuses: 'Todos los Estados',
    },
    table: {
      aria: 'Lista de Recibos de Maquila',
      columns: {
        receiptNumber: 'Recibo #',
        customer: 'Cliente',
        facility: 'Instalación',
        receivedAt: 'Recibido',
        itemCount: 'Artículos',
        status: 'Estado',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar recibos de maquila: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron recibos de maquila',
      subtitle:
        'Ningún recibo de maquila coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo recibo de maquila.',
    },
    dialog: {
      createTitle: 'Crear Recibo de Maquila',
      editTitle: 'Editar Recibo de Maquila',
      receiptNumberLabel: 'Número de Recibo',
      receiptNumberPlaceholder: 'Ingrese número de recibo...',
      customerLabel: 'Cliente',
      customerPlaceholder: 'Ingrese ID de cuenta de cliente...',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione instalación...',
      agreementLabel: 'Acuerdo de Maquila de Procesamiento',
      receivedAtLabel: 'Recibido',
      statusLabel: 'Estado',
      notesLabel: 'Notas',
      notesPlaceholder: 'Ingrese notas...',
      itemsLabel: 'Líneas de Artículos',
      addItem: 'Agregar Artículo',
      noItems:
        'No se han agregado artículos. Haga clic en "Agregar Artículo" para agregar líneas de artículos.',
      cancel: 'Cancelar',
      create: 'Crear',
      creating: 'Creando...',
      update: 'Actualizar',
      updating: 'Actualizando...',
      createSuccess: 'Recibo de maquila creado exitosamente',
      updateSuccess: 'Recibo de maquila actualizado exitosamente',
      createError: (message: string) =>
        `Error al crear recibo de maquila: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar recibo de maquila: ${message}`,
      validation: {
        receiptNumberRequired: 'El número de recibo es obligatorio',
        customerRequired: 'El cliente es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
  },
  tollShipmentsView: {
    title: 'Envíos de Maquila',
    subtitle: 'Seguimiento de envíos de material de maquila saliente',
    createTollShipment: 'Crear Envío de Maquila',
    filters: {
      search: 'Buscar envíos de maquila...',
      allCustomers: 'Todos los Clientes',
      allAgreements: 'Todos los Acuerdos',
      allFacilities: 'Todas las Instalaciones',
      allStatuses: 'Todos los Estados',
    },
    table: {
      aria: 'Lista de Envíos de Maquila',
      columns: {
        shipmentNumber: 'Envío #',
        customer: 'Cliente',
        facility: 'Instalación',
        shippedAt: 'Enviado',
        itemCount: 'Artículos',
        processingFee: 'Tarifa de Procesamiento',
        status: 'Estado',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar envíos de maquila: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron envíos de maquila',
      subtitle:
        'Ningún envío de maquila coincide con sus filtros actuales. Intente ajustar sus criterios de búsqueda o cree un nuevo envío de maquila.',
    },
    dialog: {
      createTitle: 'Crear Envío de Maquila',
      editTitle: 'Editar Envío de Maquila',
      shipmentNumberLabel: 'Número de Envío',
      shipmentNumberPlaceholder: 'Ingrese número de envío...',
      customerLabel: 'Cliente',
      customerPlaceholder: 'Ingrese ID de cuenta de cliente...',
      facilityLabel: 'Instalación',
      facilityPlaceholder: 'Seleccione instalación...',
      agreementLabel: 'Acuerdo de Maquila de Procesamiento',
      shippedAtLabel: 'Enviado',
      statusLabel: 'Estado',
      processingFeeLabel: 'Tarifa de Procesamiento',
      currencyLabel: 'Moneda',
      notesLabel: 'Notas',
      notesPlaceholder: 'Ingrese notas...',
      itemsLabel: 'Líneas de Artículos',
      addItem: 'Agregar Artículo',
      noItems:
        'No se han agregado artículos. Haga clic en "Agregar Artículo" para agregar líneas de artículos.',
      cancel: 'Cancelar',
      create: 'Crear',
      creating: 'Creando...',
      update: 'Actualizar',
      updating: 'Actualizando...',
      createSuccess: 'Envío de maquila creado exitosamente',
      updateSuccess: 'Envío de maquila actualizado exitosamente',
      createError: (message: string) =>
        `Error al crear envío de maquila: ${message}`,
      updateError: (message: string) =>
        `Error al actualizar envío de maquila: ${message}`,
      validation: {
        shipmentNumberRequired: 'El número de envío es obligatorio',
        customerRequired: 'El cliente es obligatorio',
        facilityRequired: 'La instalación es obligatoria',
      },
    },
  },
  units: {
    pounds: 'Libras',
    kilograms: 'Kilogramos',
    metricTons: 'TM',
    shortTons: 'TC',
    each: 'Cada uno',
    lb: 'LB',
    kg: 'KG',
    mt: 'TM',
    st: 'TC',
    ea: 'EA',
  },
  statuses: {
    draft: 'Borrador',
    received: 'Recibido',
    processing: 'Procesando',
    completed: 'Completado',
    cancelled: 'Cancelado',
    shipped: 'Enviado',
    delivered: 'Entregado',
  },
  itemFields: {
    itemId: 'ID de Artículo',
    quantity: 'Cantidad',
    unit: 'Unidad',
    removeItem: 'Eliminar artículo',
    none: 'Ninguno',
    selectItem: 'Seleccione artículo...',
  },
};

export type TranslationsType = typeof es;
